module.exports = "img/1.8050da.webp";